import type { TagProps } from "./tag.type";

import { Tag as AntdTag } from "antd";
import classNames from "classnames";

import "./tag.style.less";

export const Tag = ({
  ref,
  color,
  variant = "outlined",
  size = "default",
  className,
  children,
  ...tagProps
}: TagProps) => {
  /**
   * We need to cast the color prop to a valid value of TagProps["color"] because
   * Antd type don't accept custom hexademical colors, even if Tag component support them.
   */

  return (
    <AntdTag
      ref={ref}
      color={color}
      variant={variant}
      className={classNames(className, {
        [`tag-size-${size}`]: size !== "default",
      })}
      {...tagProps}
    >
      {children}
    </AntdTag>
  );
};
